import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounce, debounceTime, filter, tap } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  @Output() change = new EventEmitter<string>();
  @Input() value: string = '';
  lastValue: string = '';

  keyup$ = new Subject<string>();
  constructor() {}

  ngOnInit() {
    this.keyup$
      .pipe(
        // tap(search => ,
        untilDestroyed(this),
        filter(search => search !== this.lastValue),
        debounceTime(250),
        tap(search => {
          this.lastValue = search;
          this.change.emit(search);
        })
      )
      .subscribe();
  }

  searchChange(e){
    this.keyup$.next(e.target.value);
  }
  ngOnDestroy(): void {}
}
